import View from 'view/view'

const Collapsible = View.extend({
    events: {
        'click .js-collapsible-trigger': '_onCollapsibleTriggerClick',
    },

    _onCollapsibleTriggerClick(e) {
        e.preventDefault()
        this.$el.toggleClass('is-closed')
        this.trigger(this.$el.hasClass('is-closed') ? 'Collapsible:close' : 'Collapsible:open')
    },
})

export default Collapsible
